import { connect } from 'react-redux';
import ErrorMessage from './errorMessage';

const mapStateToProps = state => ({
  fallbackUrl: state.pdfContent.expiredFallbackEndpoint,
});

export default connect(mapStateToProps)(ErrorMessage);
